import React from 'react';
import { HStack, View } from 'native-base';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';
import { Maybe } from '@springbig/shared/src/services/dutchie/schema-types';

export type PriceTagProps = {
    price: Maybe<number> | undefined;
    discountedPrice?: Maybe<number> | undefined;
    fontSize?: number;
};

export const PriceTag = ({
    price,
    discountedPrice,
    fontSize = 11,
}: PriceTagProps) => {

    const { button_background } = useShopStyles();

    const discountedPriceFontSize = Math.round(fontSize * 1.20);

    return (
        <HStack space={1}>
            { discountedPrice &&
                <View
                    opacity={.4}
                    style={{
                        position: 'absolute',
                        transform: [{ rotate: '7deg' }],
                        top: 7,
                        width: '100%',
                        height: 1,
                        borderBottomWidth: 1,
                    }}
                />
            }
            <Caption fontSize={fontSize} opacity={discountedPrice ? .7 : 1} >
                ${ price }
            </Caption>
            { discountedPrice &&
                <Caption
                    fontSize={discountedPriceFontSize}
                    position={'absolute'}
                    right={'-50%'}
                    top={'-50%'}
                    fontWeight={'bold'}
                    color={button_background}
                >
                    ${ discountedPrice }
                </Caption>
            }
        </HStack>
    );
};
